export const ASSETS = {
  logo:
    "https://customer-assets.emergentagent.com/job_ae8da9de-5653-4337-9825-417050ee9948/artifacts/9x7fwazs_ChatGPT%20Image%20May%2027%2C%202026%2C%2008_42_52%20PM.png",
  brochureView: `${process.env.REACT_APP_BACKEND_URL}/api/brochure`,
  brochureDownload: `${process.env.REACT_APP_BACKEND_URL}/api/brochure?download=true`,
  heroTexture:
    "https://images.unsplash.com/photo-1604147706283-d7119b5b822c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxiZWlnZSUyMHRleHR1cmV8ZW58MHx8fHwxNzgxMzYxOTM2fDA&ixlib=rb-4.1.0&q=85",
  calmWoman:
    "https://images.unsplash.com/photo-1526724038726-3007ffb8025f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzZ8MHwxfHNlYXJjaHwxfHxjYWxtJTIwd29tYW4lMjB0aGVyYXB5JTIwd2VsbG5lc3N8ZW58MHx8fHwxNzgxMzYxOTIzfDA&ixlib=rb-4.1.0&q=85",
  lotus:
    "https://images.pexels.com/photos/27451405/pexels-photo-27451405.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const PHONE = "9833368600";
export const WHATSAPP_LINK = `https://wa.me/91${PHONE}?text=${encodeURIComponent(
  "Hello Bloom & Heal, I would like to know more about Bach Flower Remedies."
)}`;

export const GOOGLE_BUSINESS_URL =
  "https://www.google.com/search?q=Bloom+%26+Heal&stick=H4sIAAAAAAAA_-NgU1I1qDBOSjVPNjdLNTZNSjM3ME-xMqgwTbZMSjQ3TDFPTTRLNTOwXMTK45STn5-roKbgkZqYAwBhPObLOAAAAA";

export const INSTAGRAM_URL = "https://instagram.com/bloomandheal1";
export const INSTAGRAM_HANDLE = "bloomandheal1";
